import { render, staticRenderFns } from "./MessageElementsSelector.vue?vue&type=template&id=46e50a50&scoped=true&"
import script from "./MessageElementsSelector.vue?vue&type=script&lang=babel&"
export * from "./MessageElementsSelector.vue?vue&type=script&lang=babel&"
import style0 from "./MessageElementsSelector.vue?vue&type=style&index=0&id=46e50a50&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e50a50",
  null
  
)

export default component.exports